var SupportFileType = /* @__PURE__ */ ((SupportFileType2) => {
  SupportFileType2["ScopeReference"] = "ScopeReference";
  SupportFileType2["ScopeResource"] = "ScopeResource";
  return SupportFileType2;
})(SupportFileType || {});
var AnalysisState = /* @__PURE__ */ ((AnalysisState2) => {
  AnalysisState2["Active"] = "Active";
  AnalysisState2["Disabled"] = "Disabled";
  return AnalysisState2;
})(AnalysisState || {});
var AnalysisStatus = /* @__PURE__ */ ((AnalysisStatus2) => {
  AnalysisStatus2["NotStarted"] = "NotStarted";
  AnalysisStatus2["InProgress"] = "InProgress";
  AnalysisStatus2["Completed"] = "Completed";
  AnalysisStatus2["Deprecated"] = "Deprecated";
  return AnalysisStatus2;
})(AnalysisStatus || {});
var AnalysisType = /* @__PURE__ */ ((AnalysisType2) => {
  AnalysisType2["AB"] = "AB";
  AnalysisType2["Interleaving"] = "Interleaving";
  AnalysisType2["SeedFinder"] = "SeedFinder";
  AnalysisType2["RetrospectiveAA"] = "RetrospectiveAA";
  AnalysisType2["AAStream"] = "AAStream";
  AnalysisType2["ForayApp"] = "ForayApp";
  return AnalysisType2;
})(AnalysisType || {});
var TriggerOperator = /* @__PURE__ */ ((TriggerOperator2) => {
  TriggerOperator2[TriggerOperator2["equals"] = 0] = "equals";
  TriggerOperator2[TriggerOperator2["notEquals"] = 1] = "notEquals";
  return TriggerOperator2;
})(TriggerOperator || {});
var ScorecardPurpose = /* @__PURE__ */ ((ScorecardPurpose2) => {
  ScorecardPurpose2["Unknown"] = "Unknown";
  ScorecardPurpose2["StartFast"] = "StartFast";
  ScorecardPurpose2["FastFail"] = "FastFail";
  ScorecardPurpose2["FastFailNoSLA"] = "FastFailNoSLA";
  ScorecardPurpose2["ShipDecision"] = "ShipDecision";
  ScorecardPurpose2["ShipDecisionNoSLA"] = "ShipDecisionNoSLA";
  ScorecardPurpose2["CustomerRequested"] = "CustomerRequested";
  ScorecardPurpose2["NonProduction"] = "NonProduction";
  ScorecardPurpose2["PreviewScorecard"] = "PreviewScorecard";
  ScorecardPurpose2["FastPreviewScorecard"] = "FastPreviewScorecard";
  ScorecardPurpose2["LowPriorityPreviewScorecard"] = "LowPriorityPreviewScorecard";
  return ScorecardPurpose2;
})(ScorecardPurpose || {});
var ComputePipelineType = /* @__PURE__ */ ((ComputePipelineType2) => {
  ComputePipelineType2["Cosmos"] = "Cosmos";
  ComputePipelineType2["AzureExpSpark"] = "AzureExpSpark";
  return ComputePipelineType2;
})(ComputePipelineType || {});
var AnalysisFilterOperator = /* @__PURE__ */ ((AnalysisFilterOperator2) => {
  AnalysisFilterOperator2["CustomFilterOn"] = "CustomFilterOn";
  AnalysisFilterOperator2["CustomSessionTriggerOn"] = "CustomSessionTriggerOn";
  AnalysisFilterOperator2["CustomSideViewTriggerOn"] = "CustomSideViewTriggerOn";
  AnalysisFilterOperator2["CustomTriggerComplementOn"] = "CustomTriggerComplementOn";
  AnalysisFilterOperator2["CustomTriggerOn"] = "CustomTriggerOn";
  AnalysisFilterOperator2["CustomWhere"] = "CustomWhere";
  AnalysisFilterOperator2["EqualTo"] = "EqualTo";
  AnalysisFilterOperator2["GreaterThan"] = "GreaterThan";
  AnalysisFilterOperator2["GreaterThanOrEqualTo"] = "GreaterThanOrEqualTo";
  AnalysisFilterOperator2["InDateRange"] = "InDateRange";
  AnalysisFilterOperator2["IsIn"] = "IsIn";
  AnalysisFilterOperator2["IsNotIn"] = "IsNotIn";
  AnalysisFilterOperator2["IsTrue"] = "IsTrue";
  AnalysisFilterOperator2["LessThan"] = "LessThan";
  AnalysisFilterOperator2["LessThanOrEqualTo"] = "LessThanOrEqualTo";
  AnalysisFilterOperator2["NotSupportedOperator"] = "NotSupportedOperator";
  AnalysisFilterOperator2["RegexMatch"] = "RegexMatch";
  AnalysisFilterOperator2["RegexNotMatch"] = "RegexNotMatch";
  AnalysisFilterOperator2["SideViewTrigger"] = "SideViewTrigger";
  return AnalysisFilterOperator2;
})(AnalysisFilterOperator || {});
var Origin = /* @__PURE__ */ ((Origin2) => {
  Origin2["AnalysisTemplate"] = "AnalysisTemplate";
  Origin2["Experiment"] = "Experiment";
  Origin2["UserDefined"] = "UserDefined";
  return Origin2;
})(Origin || {});
var ScorecardRequestState = /* @__PURE__ */ ((ScorecardRequestState2) => {
  ScorecardRequestState2["Waiting"] = "Waiting";
  ScorecardRequestState2["ReadyForSubmission"] = "ReadyForSubmission";
  ScorecardRequestState2["SubmittingToPipeline"] = "SubmittingToPipeline";
  ScorecardRequestState2["SubmittedToCluster"] = "SubmittedToCluster";
  ScorecardRequestState2["Running"] = "Running";
  ScorecardRequestState2["Completed"] = "Completed";
  ScorecardRequestState2["Failed"] = "Failed";
  ScorecardRequestState2["Cancelled"] = "Cancelled";
  ScorecardRequestState2["WaitingForData"] = "WaitingForData";
  ScorecardRequestState2["WaitingForComputeResource"] = "WaitingForComputeResource";
  ScorecardRequestState2["CancelledByVC"] = "CancelledByVC";
  ScorecardRequestState2["CancelledByUser"] = "CancelledByUser";
  ScorecardRequestState2["CancelledByExP"] = "CancelledByExP";
  return ScorecardRequestState2;
})(ScorecardRequestState || {});
var TimeUnit = /* @__PURE__ */ ((TimeUnit2) => {
  TimeUnit2["Day"] = "Day";
  TimeUnit2["Hour"] = "Hour";
  TimeUnit2["Minute"] = "Minute";
  return TimeUnit2;
})(TimeUnit || {});
var ScorecardRequestLogOrigin = /* @__PURE__ */ ((ScorecardRequestLogOrigin2) => {
  ScorecardRequestLogOrigin2["AnalysisEngine"] = "AnalysisEngine";
  ScorecardRequestLogOrigin2["JobPipeline"] = "JobPipeline";
  return ScorecardRequestLogOrigin2;
})(ScorecardRequestLogOrigin || {});
export {
  AnalysisFilterOperator,
  AnalysisState,
  AnalysisStatus,
  AnalysisType,
  ComputePipelineType,
  Origin,
  ScorecardPurpose,
  ScorecardRequestLogOrigin,
  ScorecardRequestState,
  SupportFileType,
  TimeUnit,
  TriggerOperator
};
//# sourceMappingURL=AnalysisModels.js.map
